import React from 'react'
import { Link, useLocation } from "react-router-dom";

//reommendation pages array
const pages = [
    {
        path: "/compress_pdf",
        title: "Compress PDF Online",
        description: "Compress PDF files online to reduce file size while maintaining document quality."
    },
    {
        path: "/compress_pdf_under_200_kb",
        title: "Compress PDF Under 200 KB",
        description: "Reduce PDF file size under 200 KB for easy uploading, sharing, and submission."
    },
    {
        path: "/merge_pdf",
        title: "Merge PDF Files",
        description: "Combine multiple PDF files into one document quickly and easily."
    },
    {
        path: "/split_pdf",
        title: "Split PDF Online",
        description: "Split PDF documents into separate files or extract specific pages."
    },
    {
        path: "/pdf_to_image",
        title: "PDF to Image Converter",
        description: "Convert PDF pages into high-quality JPG and PNG images."
    },
    {
        path: "/image_to_pdf",
        title: "Image to PDF Converter",
        description: "Convert multiple JPG and PNG images into a single PDF document."
    },
    {
        path: "/lock_pdf",
        title: "Protect PDF with Password",
        description: "Add password protection to PDF documents to secure sensitive information."
    },
    {
        path: "/unlock_pdf",
        title: "Unlock PDF Online",
        description: "Remove password protection from PDF files when you have the required authorization."
    },
    {
        path: "/watermark_pdf",
        title: "Add Watermark to PDF",
        description: "Add custom text or image watermarks to PDF documents."
    },
    {
        path: "/resize_pdf",
        title: "Resize PDF Pages",
        description: "Resize PDF pages to standard paper sizes or custom dimensions."
    },
    {
        path: "/grayscale_pdf",
        title: "Convert PDF to Grayscale",
        description: "Convert colorful PDF documents into grayscale or black and white PDFs."
    },
    {
        path: "/pdf_metadata_editor",
        title: "PDF Metadata Editor",
        description: "Edit PDF metadata including document title, author, subject, and keywords."
    },
    {
        path: "/flatten_pdf",
        title: "Flatten PDF Online",
        description: "Flatten PDF forms and annotations to create a simplified document."
    },
    {
        path: "/extract_pdf_pages",
        title: "Extract Pages from PDF",
        description: "Extract selected pages from PDF files and save them as a new document."
    },
    {
        path: "/pdf_editor",
        title: "Edit PDF Online",
        description: "Edit PDF documents by adding text, images, and other content."
    },
    {
        path: "/delete_pdf_pages",
        title: "Delete Pages from PDF",
        description: "Remove unwanted pages from PDF documents quickly and easily."
    },
    {
        path: "/rearrange_pdf",
        title: "Rearrange PDF Pages",
        description: "Reorder PDF pages by moving them into your preferred sequence."
    },
    {
        path: "/rotate_pdf",
        title: "Rotate PDF Pages",
        description: "Rotate PDF pages clockwise or counterclockwise and save the corrected document."
    },
    {
        path: "/add_pages_pdf",
        title: "Add Blank Pages to PDF",
        description: "Insert blank pages into PDF documents at your preferred positions."
    },
    {
        path: "/document_scanner",
        title: "Free Online Document Scanner",
        description: "Scan documents using your camera and create digital document files."
    },
    {
        path: "/number_pdf_pages",
        title: "Add Page Numbers to PDF",
        description: "Add customizable page numbers to PDF documents in your preferred position."
    },
    {
        path: "/pdf_n_up_tool",
        title: "PDF N-Up Tool",
        description: "Combine multiple PDF pages onto a single sheet to save paper and printing space."
    },
    {
        path: "/html_to_pdf",
        title: "HTML to PDF Converter",
        description: "Convert HTML content and web documents into PDF files."
    },
    {
        path: "/pdf_viewer",
        title: "Free Online PDF Viewer",
        description: "Open and view PDF documents online without installing additional software."
    },
    {
        path: "/crop_pdf",
        title: "Crop PDF Online",
        description: "Crop PDF pages to remove unwanted margins and adjust page boundaries."
    },
    {
        path: "/compress_files",
        title: "Compress Files Online",
        description: "Compress files into smaller sizes for easier storage and sharing."
    },
    {
        path: "/image_converter",
        title: "Free Online Image Converter",
        description: "Convert images between popular formats such as JPG, PNG, and other image types."
    },
    {
        path: "/qr_scanner",
        title: "Free Online QR Code Scanner",
        description: "Scan QR codes online to quickly read embedded text, links, and other information."
    },
    {
        path: "/qr_generator",
        title: "Free QR Code Generator",
        description: "Generate custom QR codes for URLs, text, contact details, and other information."
    },
    {
        path: "/pdf_converter",
        title: "Online PDF Converter",
        description: "Convert PDF documents into different file formats and transform files into PDF."
    },
    {
        path: "/pdf_ocr",
        title: "OCR PDF Online",
        description: "Extract searchable text from scanned PDF documents using optical character recognition."
    },
    {
        path: "/ppt_to_pdf",
        title: "PowerPoint to PDF Converter",
        description: "Convert PowerPoint presentations into PDF documents for easy sharing."
    },
    {
        path: "/pdf_to_ppt",
        title: "PDF to PowerPoint Converter",
        description: "Convert PDF documents into editable PowerPoint presentations."
    },
    {
        path: "/excel_to_pdf",
        title: "Excel to PDF Converter",
        description: "Convert Excel spreadsheets into PDF documents while preserving their layout."
    },
    {
        path: "/pdf_to_excel",
        title: "PDF to Excel Converter",
        description: "Convert PDF tables and documents into editable Excel spreadsheets."
    },
    {
        path: "/word_to_pdf",
        title: "Word to PDF Converter",
        description: "Convert Word documents into PDF files while preserving document formatting."
    },
    {
        path: "/pdf_to_word",
        title: "PDF to Word Converter",
        description: "Convert PDF documents into editable Word files."
    },
    {
        path: "/pdf_annotator",
        title: "Annotate PDF Online",
        description: "Add highlights, comments, drawings, and annotations to PDF documents."
    },
    {
        path: "/image_resizer",
        title: "Resize Images Online",
        description: "Resize images to custom dimensions while maintaining the desired image quality."
    },
    {
        path: "/merge_images",
        title: "Merge Images Online",
        description: "Combine multiple images into one picture quickly and easily."
    },
    {
        path: "/split_image",
        title: "Split Image Online",
        description: "Split images into multiple sections or smaller image segments."
    },
    {
        path: "/watermark_image",
        title: "Add Watermark to Image",
        description: "Add custom text or image watermarks to protect your pictures."
    },
    {
        path: "/flip_image",
        title: "Flip Images Online",
        description: "Flip images horizontally or vertically to change their orientation."
    },
    {
        path: "/crop_image",
        title: "Crop Images Online",
        description: "Crop images to remove unwanted areas and create your preferred composition."
    },
    {
        path: "/html_to_image",
        title: "HTML to Image Converter",
        description: "Convert HTML content and web layouts into image files."
    },
    {
        path: "/repair_pdf",
        title: "Repair PDF Online",
        description: "Try to repair damaged or corrupted PDF documents and restore accessible content."
    },
    {
        path: "/upscale_image",
        title: "Upscale Images Online",
        description: "Increase image resolution and improve picture quality with online image upscaling."
    }
]

const MiscRecommendedPages = ({ count = 6 }) => {
    //location
  const location = useLocation();

  // Exclude current page
  const currentPath = location.pathname.replace(/\/$/, "") || "/";

  //start index
  const startIndex = Math.min(pages.length - count, Math.random() * pages.length);
  // Select recommendations
  const recommendations = pages
    .filter((page) => page.path !== currentPath)
    .slice(startIndex, startIndex + count);

  return (
    <section className="container my-5">
      <div className="border-top pt-5">
        <h2 className="h4 fw-bold mb-1">
          Recommended Tools
        </h2>

        <p className="text-muted mb-5">
          Explore more free online PDF tools.
        </p>

        <div className="row g-3">
          {recommendations.map((page) => (
            <div className="col-12 col-md-6 col-lg-4" key={page.path}>
              <Link
                to={page.path}
                className="card h-100 text-decoration-none text-dark shadow-sm"
              >
                <div className="card-body">
                  <span className="badge bg-light text-primary mb-2">
                    {page.category}
                  </span>

                  <h3 className="h6 fw-bold">
                    {page.title}
                  </h3>

                  <p className="text-muted small mb-0">
                    {page.description}
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MiscRecommendedPages;